export default "__VITE_ASSET__6106c5fc__"